<div class="auction-detail-cntr">

    <p-card [header]="configuration.batch.ProductName" [subheader]="configuration.batch.ProductQuantity + 'kg'" [style]="{ width: '100%' }">

        <ng-template pTemplate="header">

            <img alt="Card" *ngIf="configuration.batch.ProductFiles.length" [src]="configuration.batch.ProductFiles[0].Endpoint" />

            <div class="seller-absolute" *ngIf="sellerConfiguration">
                    <fb-seller-info [configuration]="sellerConfiguration"></fb-seller-info>
            </div>

        </ng-template>

        <p>
            {{configuration.batch.ProductDescription}}
        </p>

    </p-card>

    <div class="button-cntr" *ngIf="priceButtonConfiguration">

        <auction-detail-button *ngIf="priceButtonConfiguration" [configuration]="priceButtonConfiguration"></auction-detail-button>

    </div>


    <fb-auction *ngIf="auctionConfiguration" [configuration]="auctionConfiguration"></fb-auction>


</div>
